export default __webpack_public_path__ + "static/burring-cd7aea79dd279d7cb54b8e55537bda99.png";